import { useLocation } from "react-router-dom";
import { LocalizedLink } from "@/components/LocalizedLink";
import { useLocale } from "@/locale/LocaleProvider";
import { pickSeoServicesNav } from "@/locale/content/seoServicesNav";
import { parseLocalePath } from "@/locale/routes";

/**
 * Контекстная перелинковка услуг перед основным footer — распределение PageRank по целевым URL.
 */
const SeoServicesNav = () => {
  const { lang } = useLocale();
  const { pathname } = useLocation();
  const { basePath } = parseLocalePath(pathname);
  const { sectionTitle, sectionSubtitle, navAriaLabel, links } = pickSeoServicesNav(lang);

  return (
    <section
      className="border-t border-slate-200/80 bg-slate-50"
      aria-labelledby="seo-services-nav-heading"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12 min-w-0">
        <header className="mb-6 sm:mb-8 max-w-3xl">
          <h2 id="seo-services-nav-heading" className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
            {sectionTitle}
          </h2>
          <p className="mt-2 text-sm sm:text-base text-muted-foreground leading-relaxed">{sectionSubtitle}</p>
        </header>

        <nav aria-label={navAriaLabel}>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 list-none m-0 p-0">
            {links.map((link) => {
              const isCurrent = basePath === link.href;
              return (
                <li key={link.href}>
                  <LocalizedLink
                    to={link.href}
                    aria-current={isCurrent ? "page" : undefined}
                    className={[
                      "group flex min-h-11 items-center rounded-lg border px-3 py-2.5 sm:px-4 sm:py-3",
                      "text-sm sm:text-[0.9375rem] font-medium leading-snug transition-colors duration-200",
                      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2",
                      isCurrent
                        ? "border-blue-600/40 bg-blue-50 text-blue-800"
                        : "border-slate-200/90 bg-white text-slate-800 shadow-sm hover:border-blue-300 hover:bg-blue-50/60 hover:text-blue-800",
                    ].join(" ")}
                  >
                    <span className="break-words">{link.label}</span>
                  </LocalizedLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default SeoServicesNav;
